import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "absolute inset-0 z-1" }
const _hoisted_2 = { class: "relative" }

import { computed } from 'vue';
import { isReadable } from '@ctrl/tinycolor';
import { LinkViewModel, MediaModel } from '@/types/B2CcontentServerContract';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import RouterLinkConditional from '@/core/navigation/router-link-conditional.vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';

export interface TileContent {
    subheading?: string;
    title?: string;
    text?: string;
    link?: LinkViewModel;
    media?: MediaModel;
    zoom?: boolean;
}

interface Props {
    backgroundColor?: string;
    textColor?: string;
    alternativeLinkStyle?: boolean;
    linkAtBottomOfImage?: boolean;
    flipImageAndText?: boolean;
    textTileContentBlock?: TileContent;
    mediaTileContentBlock?: TileContent;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLayout2575and7525',
  props: {
    backgroundColor: { default: undefined },
    textColor: { default: undefined },
    alternativeLinkStyle: { type: Boolean, default: false },
    linkAtBottomOfImage: { type: Boolean, default: false },
    flipImageAndText: { type: Boolean, default: false },
    textTileContentBlock: { default: undefined },
    mediaTileContentBlock: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { backgroundColor: string, textColor: string, alternativeLinkStyle: boolean, linkAtBottomOfImage: boolean, flipImageAndText: boolean, textTileContentBlock: TileContent, mediaTileContentBlock: TileContent }



const aspectRatio = { xs: 1, sm: 4 / 3, default: 40 / 27 };

const linkPositionClass = computed<string>(() => {
    return props.linkAtBottomOfImage ? 'justify-end pb-15 md:pb-30 xl:pb-50' : 'justify-center';
});

const flexOrderClass = computed<string>(() => {
    return props.flipImageAndText ? 'flex-col md:flex-row' : 'flex-col md:flex-row-reverse';
});

const textColorClass = computed<string>(() => {
    return invertTextColor.value ? 'text-white' : 'text-black';
});

const textPaddingClass = computed<string>(() => {
    return props.flipImageAndText ? 'pb-x1 md:pl-x5 lg:pl-x8' : 'pt-x1 md:pr-x5 lg:pr-x8';
});

const textPositionClass = computed<string>(() => {
    return props.flipImageAndText ? 'text-right' : '';
});

const invertTextColor = computed<boolean>(() => {
    return !!props.backgroundColor && !isReadable('#000', props.backgroundColor);
});

const linkForImage = computed<LinkViewModel | undefined>(() => {
    if (props.mediaTileContentBlock?.link) {
        return props.mediaTileContentBlock?.link;
    } else if (props.textTileContentBlock.link) {
        return props.textTileContentBlock.link;
    } else {
        return undefined;
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockMaxWidthHandler, null, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        class: _normalizeClass(["flex md:items-center", [_unref(flexOrderClass)]]),
        style: _normalizeStyle({ backgroundColor : __props.backgroundColor })
      }, [
        _createElementVNode("section", {
          class: "relative md:w-2/3",
          style: _normalizeStyle({ color: __props.textColor })
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex flex-col h-full items-center mx-auto text-center text-current-color w-2/3", [_unref(linkPositionClass)]])
            }, [
              (__props.mediaTileContentBlock)
                ? (_openBlock(), _createBlock(TextBlockHandler, {
                    key: 0,
                    heading: __props.mediaTileContentBlock.subheading,
                    title: __props.mediaTileContentBlock.title,
                    text: __props.mediaTileContentBlock.text,
                    "link-url": __props.mediaTileContentBlock.link?.url,
                    "link-target": __props.mediaTileContentBlock.link?.target,
                    "link-text": __props.mediaTileContentBlock.link?.text,
                    "link-is-spa-link": __props.mediaTileContentBlock.link?.spaLink,
                    "link-style-as-button": true
                  }, null, 8, ["heading", "title", "text", "link-url", "link-target", "link-text", "link-is-spa-link"]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_2, [
            (__props.mediaTileContentBlock?.media)
              ? (_openBlock(), _createBlock(MediaHandler, {
                  key: 0,
                  "media-aspect-ratio": aspectRatio,
                  "media-block": __props.mediaTileContentBlock.media
                }, null, 8, ["media-block"]))
              : _createCommentVNode("", true),
            (_unref(linkForImage))
              ? (_openBlock(), _createBlock(RouterLinkConditional, {
                  key: 1,
                  class: "absolute inset-0 z-1",
                  to: _unref(linkForImage)?.url,
                  "spa-enabled": _unref(linkForImage)?.spaLink
                }, null, 8, ["to", "spa-enabled"]))
              : _createCommentVNode("", true)
          ])
        ], 4),
        _createElementVNode("section", {
          class: _normalizeClass(["break-words w-full pt-x3 md:pt-0 md:w-1/3", [_unref(textPaddingClass), _unref(textPositionClass), _unref(textColorClass)]])
        }, [
          (__props.textTileContentBlock)
            ? (_openBlock(), _createBlock(TextBlockHandler, {
                key: 0,
                heading: __props.textTileContentBlock.subheading,
                title: __props.textTileContentBlock.title,
                text: __props.textTileContentBlock.text,
                "link-url": __props.textTileContentBlock.link?.url,
                "link-target": __props.textTileContentBlock.link?.target,
                "link-text": __props.textTileContentBlock.link?.text,
                "link-is-spa-link": __props.textTileContentBlock.link?.spaLink,
                "link-style-as-button": !__props.alternativeLinkStyle
              }, null, 8, ["heading", "title", "text", "link-url", "link-target", "link-text", "link-is-spa-link", "link-style-as-button"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 6)
    ]),
    _: 1
  }))
}
}

})